<script setup lang="ts">
/**
 * @author Giorgi Tseradze
 */

//
import BigBox from "@/components/smartComponents/ConstructionStages/parts/BigBox.vue";
import SmallBox from "@/components/smartComponents/ConstructionStages/parts/SmallBox.vue";
import MediumBox from "@/components/smartComponents/ConstructionStages/parts/MediumBox.vue";
import { SecondaryDataInterface } from "@/types/ContentType";
import { onMounted, onBeforeMount, Ref, ref } from "vue";
import { useMainStore } from "@/store/main/index";
import { ImageInterface } from "@/types/ContentType";
import { StageData } from "./types/Stages.Interface";

const props = defineProps<{
  contentData: SecondaryDataInterface;
}>();

const mainStore = useMainStore();
const activeIndex = ref(0);
const prevActive = ref(true);
const nextActive = ref(false);
const stageData: Ref<StageData[]> = ref([]);
const images: Ref<ImageInterface[]> = ref([]);

const handlePrev = () => {
  if (activeIndex?.value > 0) {
    activeIndex.value -= 1;
  }
  if (activeIndex?.value === 0) {
    prevActive.value = false;
  }
  nextActive.value = true;
  handleStageData();
};
const handleNext = () => {
  if (!props?.contentData?.data?.listCount) return;

  if (activeIndex?.value < props?.contentData?.data?.listCount - 1) {
    activeIndex.value += 1;
    if (activeIndex?.value === props?.contentData?.data?.listCount - 1) {
      nextActive.value = false;
    }
  }
  prevActive.value = true;
  handleStageData();
};

const handleActiveIndex = () => {
  if (!props?.contentData?.data?.listCount) return;
  activeIndex.value = props?.contentData?.data?.listCount - 1;
};

const handleImages = (data: ImageInterface[]) => {
  if (!data) return;
  data?.map((item) => {
    images?.value?.push(item);

    stageData?.value?.push({
      image: item,
      isImage: true,
      isDate: false,
      isPercentage: false,
    });
  });
};

//get stageData from all rows. photos, date and percent
const handleStageData = () => {
  stageData.value = [];
  images.value = [];

  handleImages(props?.contentData?.data?.list?.[activeIndex?.value]?.row_1);

  handleImages(props?.contentData?.data?.list?.[activeIndex?.value]?.row_2);

  handleImages(props?.contentData?.data?.list?.[activeIndex?.value]?.row_3);

  stageData?.value?.push({
    date: props?.contentData?.data?.list?.[activeIndex?.value]?.date,
    isImage: false,
    isDate: true,
    isPercentage: false,
  });

  stageData?.value?.push({
    percent: props?.contentData?.data?.list?.[activeIndex?.value]?.percent,
    isImage: false,
    isDate: false,
    isPercentage: true,
  });
};

onMounted(() => {
  prevActive.value = props.contentData?.data?.listCount > 1;
});

onBeforeMount(() => {
  handleActiveIndex();
  handleStageData();
});
</script>

<template>
  <section class="stages">
    <div class="container">
      <div class="stages__header d-flex dir-col j-center al-center">
        <div class="stages__header-title uppercase">
          <h2 class="hl-1-plus">{{ contentData?.conf?.header?.title }}</h2>
        </div>
        <div class="stages__header-teaser">
          <p class="p-16">
            {{ contentData?.conf?.header?.teaser }}
          </p>
        </div>
      </div>
      <div v-if="mainStore?.windowWidth >= 1920" class="stages__inner">
        <BigBox
          :contentData="contentData?.data?.list?.[activeIndex]"
          :nextActive="nextActive"
          :prevActive="prevActive"
          @prev="handlePrev"
          @next="handleNext"
        />
      </div>
      <div v-if="mainStore?.windowWidth <= 1919 && mainStore?.windowWidth > 983">
        <MediumBox
          :contentData="contentData?.data?.list?.[activeIndex]"
          :images="images"
          :nextActive="nextActive"
          :prevActive="prevActive"
          @prev="handlePrev"
          @next="handleNext"
        />
      </div>
      <div v-if="mainStore?.windowWidth <= 983" class="stages___carousel">
        <SmallBox
          @prev="handlePrev"
          @next="handleNext"
          :nextActive="nextActive"
          :prevActive="prevActive"
          :contentData="stageData"
        />
      </div>
    </div>
  </section>
</template>

<style lang="scss" src="./styles/stages.scss" />
